import { render } from "./SubscriptionManagement.vue?vue&type=template&id=52749647&scoped=true"
import script from "./SubscriptionManagement.vue?vue&type=script&lang=js"
export * from "./SubscriptionManagement.vue?vue&type=script&lang=js"

import "./SubscriptionManagement.vue?vue&type=style&index=0&id=52749647&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52749647"]])

export default __exports__